<template>
  <div>
    <v-row v-for='(i,index) of addCertifications' :key='index' class='mt-2'>
      <v-col cols='12' sm='2' md='2'>
        <v-text-field v-model='i.Number' outlined dense label='Номер сертификаться' type='number'></v-text-field>
      </v-col>
      <v-col cols='12' sm='2' md='2'>
        <oil-date-picker
          :item='i'
          item-key='StartDate'
          :v-input='input'
          :keys='startDateKeys'
          :attr='startDateKeys.attrs'
        />
      </v-col>
      <v-col cols='12' sm='2' md='2'>
        <oil-date-picker
          :item='i'
          item-key='EndDate'
          :v-input='input'
          :keys='endDateKeys'
          :attr='endDateKeys.attrs'
        />
      </v-col>
      <v-col cols='12' sm='2' md='2'>
        <v-text-field v-model='i.Price' outlined dense label="Сумма в долларах США" :rules='required' type='number'></v-text-field>
      </v-col>
      <v-col cols='12' sm='2' md='2'>
        <File :supplier='supplier' :item='i'/>
      </v-col>
      <v-col cols='12' sm='1' md='1' class='text-right'>
        <v-tooltip bottom>
          <template v-slot:activator='{ on, attrs }'>
            <v-btn style='box-shadow: none;color: #00b24f;background-color: transparent' :disabled='!input.isEdit'
                   @click='dow(i)'
                   v-bind='attrs'
                   v-on='on'
            >
              <v-icon>mdi-download</v-icon>
            </v-btn>
          </template>
          <span>Скачать</span>
        </v-tooltip>
      </v-col>
      <v-col cols='12' sm='1' md='1'>
        <template>
          <v-row justify="center">
            <v-dialog
              v-model="dialog"
              persistent
              max-width="300"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="red"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  icon
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
              <v-card class='pt-4'>
                <v-card-text>вы точно хотите удалить этот документ ?</v-card-text>
                <v-card-actions>



                  <v-btn
                    color="green darken-1"
                    text
                    @click="removeCertificate(index, i)"
                  >
                    Подтвердить
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn
                      color="green darken-1"
                      text
                      @click="dialog = false"
                  >
                    Отменить
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>
        </template>
<!--        <v-tooltip bottom>-->
<!--          <template v-slot:activator='{ on, attrs }'>-->
<!--            <v-btn v-bind='attrs'-->
<!--                   v-on='on' icon-->
<!--                   @click='removeCertificate(index,i)'-->
<!--            >-->
<!--              <v-icon color='red'>-->
<!--                mdi-delete-->
<!--              </v-icon>-->
<!--            </v-btn>-->
<!--          </template>-->
<!--          <span>УДАЛИТЬ СЕРТИФИКАЦИИ</span>-->
<!--        </v-tooltip>-->
      </v-col>
    </v-row>
  </div>

</template>

<script>
import File from '~/pages/supplier/settng/File'
import { coreApi } from '~/services/core'
export default {
  props: {
    items: Array,
    supplier: Object
  },
  data() {
    return {
      required: [
        v => !!v || 'Поле обязательно для ввода'
      ],
      dialog: false,
      startDateKeys: {
        attrs: {
          readonly: false,
          outlined: true,
          dense: true,
          label: 'Дата начало'
        }
      },
      endDateKeys: {
        attrs: {
          readonly: false,
          outlined: true,
          dense: true,
          label: 'Дата конец'
        }
      },
      input: { isEdit: true }
    }
  },
  components: {
    File,
    OilDatePicker: () => import('@/components/helper/form/oil.date.picker')
  },
  computed: {
    cols() {
      return this.index === 0 ? 2 : 4
    },
    addCertifications() {
      return this.items
    },

  },
  methods: {
    async removeCertificate(index, i) {
      const data = this.supplier
      if (i.Attachment) {
        await coreApi.delete(`file/${i.Attachment.Id}`)
        this.items.splice(index, 1)
        await coreApi.put('/suppler', data)
      }else{
        this.items.splice(index, 1)
        await coreApi.put('/suppler', data)
      }
      this.dialog = false
    }
  },
  created() {
    this.items ??= []
  },

}
</script>